import AES from '@ali/aes-tracker';
import send from './send';

var sendEvent = function (global) {
  return send(global, AES);
}(window);

export default sendEvent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-event@1.2.5@@ali/aes-tracker-plugin-event/es/index.js
// module id = null
// module chunks = 